import { KeycloakService } from 'keycloak-angular';
import { KEYCLOAK_UPDATE_MIN_VALIDITY_SECONDS } from './keycloak-refresh.constants';

/**
 * Neutraliza chamadas de rede do keycloak-js (workaround HML).
 * Só deve ser aplicado quando `environment.keycloak.passiveKeycloakPolicy === true`.
 * Após isto, updateToken e loadUserProfile não fazem HTTP; expiração = 401 nas APIs.
 */
type PatchedKeycloak = {
  updateToken: (minValidity?: number) => Promise<boolean>;
  loadUserProfile: (options?: { maxAge?: number }) => Promise<import('keycloak-js').KeycloakProfile>;
  token?: string;
  tokenParsed?: Record<string, unknown>;
  subject?: string;
  isTokenExpired?: (minValidity?: number) => boolean;
};

export function applyKeycloakPassivePolicy(keycloak: KeycloakService): void {
  const kc = keycloak.getKeycloakInstance() as unknown as PatchedKeycloak;

  kc.updateToken = (minValidity = KEYCLOAK_UPDATE_MIN_VALIDITY_SECONDS) => {
    if (!kc.token) {
      return Promise.resolve(false);
    }
    const expired = kc.isTokenExpired ? kc.isTokenExpired(minValidity) : false;
    return Promise.resolve(!expired);
  };

  kc.loadUserProfile = () => {
    const tp = kc.tokenParsed ?? {};
    const profile = {
      id: kc.subject ?? '',
      username: (tp['preferred_username'] as string) || '',
      email: tp['email'] as string | undefined,
      firstName: tp['given_name'] as string | undefined,
      lastName: tp['family_name'] as string | undefined,
    };
    return Promise.resolve(profile);
  };
}
